"use strict";

/**
 *
 * Sets a trap on window unload in order to prevent user from loosing data.
 *
 */
function setIncompleteTrap() {
  const message = $("body").data("oncompleteformmessage");
  if (!($("body").attr("data-unsaved-work-trigger") == "true")) {
    $("body").attr("data-unsaved-work-trigger", true);

    $(window).on("beforeunload", function() {
      return message;
    });
  }
}

function onLoad() {
  $("input").on("change input paste", setIncompleteTrap);
  $("select").on("change", setIncompleteTrap);
}

module.exports = {
  onLoad,
  setIncompleteTrap
};



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-incomplete-form/booking-incomplete-form.js